export default "__VITE_ASSET__CPD$baS1__"